export default "__VITE_ASSET__BcA$X4Qg__"